import { createContext, useState } from "react";
import { moviesData } from "../data/movies";

export const MovieContext = createContext();

export const MovieProvider = ({ children }) => {
  const [movies, setMovies] = useState(moviesData);

  const addMovie = (movie) => {
    setMovies([...movies, { id: Date.now(), ...movie }]);
  };

  return (
    <MovieContext.Provider value={{ movies, addMovie }}>
      {children}
    </MovieContext.Provider>
  );
};
